


import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import requestService from "@/service/requestService";
import { ShakenShohiyou } from "@/model/ShakenShohiyou";
import { Getter, Action } from "vuex-class";
import Number from "@/shared/filters/Number";
import { MESSAGE } from "@/model/Message";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { Utils } from "@/service/util";
import { UserService } from "@/service/UserService";
import { ElForm } from "element-ui/types/form";
import { ElButton } from "element-ui/types/button";
import InputNumber from "@/components/common/input/InputNumber.vue";
import JibaiseikiDialog from "@/components/JibaiseikiDialog.vue";
import JuuryouzeiDialog from "@/components/JuuryouzeiDialog.vue";
import { JuuryouzeiJibaiseikiSave } from "@/model/JuuryouzeiJibaiseikiSave";
import { RyoukinRank, Hikazei3, HikazeiRyoukin } from "@/model/RyoukinRank";
import TopBarTitle from '@/components/common/TopBarTitle.vue';
import { Item } from "@/model/ShakenShohiyou";
import InspectionCostPage from "@/page/user/InspectionCostPage.vue";


@Component({
  filters: {
    Number
  },
  components: {
    ConfirmDialog,
    InputNumber,
    JibaiseikiDialog,
    JuuryouzeiDialog,
    TopBarTitle
  }
})
export default class InspectionCostPageQuick extends InspectionCostPage {
  isModeModal: boolean = false;
  isModeQuick: boolean = true;

onSubmitTax() {
    this.$refs.taxForm.validate((valid: boolean) => {
      if (valid) {
        this.formData.zeiJibaisekiZn = this.formData.zeiJibaisekiZk;
        if (this.isMadoguchiInshidaiChecked) {
          this.formData.zeiInshidaiZn = this.inshidaiMadoguchi;
          this.formData.zeiInshidaiZk = this.inshidaiMadoguchi;
          this.formData.zeiInshidaiGenka = this.inshidaiMadoguchi;
        }
        this.formData.isMadoguchiInshidai = this.isMadoguchiInshidaiChecked ? 1 : 0;
        const data: JuuryouzeiJibaiseikiSave = {
          sknUketsukeExtendsId: this.uketsukeExtendsId,
          ...this.formData
        };
        /** 2021-10-01 sh #7438 implements tech info amount. [START] */
        /** 送る必要がないので、除外する */
        delete data.zeiTechInfoAmountZk;
        delete data.zeiTechInfoAmountZn;
        delete data.isUseTechInfoAmount;
        /** 2021-10-01 sh #7438 implements tech info amount. [END] */
        this.saveTaxAndRefresh(data);
      }
    });
  }

  resetKensaHiyou() {
    this.reqService.resetKensaHiyouQM(this.uketsukeExtendsId).then(
      (response: any) => {
        const userService = new UserService();
        userService.getShohiyouQM();
      },
      (err: any) => {
        this.$notify.error({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      }
    );
  }

}
